import { render, staticRenderFns } from "./Thirds.vue?vue&type=template&id=975cdf52&scoped=true"
import script from "./Thirds.vue?vue&type=script&lang=js"
export * from "./Thirds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975cdf52",
  null
  
)

export default component.exports